import i18n from 'i18next';
import Detector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import ChainedBackend from 'i18next-chained-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';
import config from './config';

// declare custom type options so the return is always a string.
declare module 'i18next' {
    interface CustomTypeOptions {
        returnNull: false
    }
}

i18n
    .use(Detector)
    .use(ChainedBackend)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        supportedLngs: config.languages,
        fallbackLng: 'en', // use en if detected lng is not available
        ns: ['remote', 'local'],
        defaultNS: 'remote',
        fallbackNS: 'local',
        interpolation: {
            escapeValue: false // react already safes from XSS attacks
        },
        backend: {
            backends: [
                HttpBackend,
                resourcesToBackend((lang: string, ns: string) => {
                    if (ns !== 'local') return false;
                    return import(`./translations/${lang}.json`);
                })
            ],
            backendOptions: [{
                loadPath: (langs: string[], nss: string[]) => {
                    if (!nss.includes('remote')) return false;
                    return config.apiUrl + '/locales/{{lng}}/translation';
                }
            }]

        },
    });

export default i18n;